import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS, getResponsiveValue } from '../styles/breakpoints';

export function NavigationTabs({ activeTab, setActiveTab }) {
  const tabs = [
    { label: "VENUES", id: "venues" },
    { label: "NEW VENUES", id: "new_venues" },
    { label: "VENUE REPORTS", id: "venue_reports" },
    { label: "USERS", id: "users" },
    { label: "SITE MANAGEMENT", id: "site" },
    { label: "APIs", id: "apis" }
  ];

  return (
    <TabsContainer>
      <TabsWrapper>
        <TabList>
          {tabs.map((tab) => (
            <TabButton 
              key={tab.id}
              $active={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </TabButton>
          ))}
        </TabList>
      </TabsWrapper>
    </TabsContainer>
  );
}

const TabsContainer = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  text-align: center;
  font-family: 'VastagoGrotesk', -apple-system, Roboto, Helvetica, sans-serif;
  font-weight: 800;
  font-size: ${getResponsiveValue({
    mobile: '14px',
    tablet: '16px',
    laptop: '20px',
    desktop: '24px'
  })};
  margin-top: ${getResponsiveValue({
    mobile: '10px',
    tablet: '10px',
    laptop: '10px',
    desktop: '10px'
  })};
`;

const TabsWrapper = styled.div`
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  width: 90vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getResponsiveValue({
    mobile: '15px 20px',
    tablet: '20px 40px',
    laptop: '30px 50px',
    desktop: '30px 50px'
  })};
`;

const TabList = styled.div`
  display: flex;
  width: 100%;
  gap: ${getResponsiveValue({
    mobile: '10px',
    tablet: '15px',
    laptop: '20px',
    desktop: '20px'
  })};
  flex-wrap: wrap;
  justify-content: center;
  margin-top: -80
`;

const TabButton = styled.button`
  border: none;
  border-radius: 10px;
  background: ${props => props.$active ? '#2ecc71' : '#424b54'};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  color: white;
  padding: ${getResponsiveValue({
    mobile: '10px 20px',
    tablet: '12px 30px',
    laptop: '14px 58px',
    desktop: '18px 58px'
  })};
  cursor: pointer;
  font-family: 'VastagoGrotesk', -apple-system, Roboto, Helvetica, sans-serif;
  font-weight: 800;
  transition: background-color 0.2s ease;
  min-width: ${getResponsiveValue({
    mobile: '120px',
    tablet: '150px',
    laptop: '180px',
    desktop: '240px'
  })};
  
  &:hover {
    background: ${props => props.$active ? '#27ae60' : '#2c3338'};
  }
  
  &:active {
    transform: translateY(1px);
  }
`; 
